module.exports = __webpack_public_path__ + "static/media/mail.4be077df.svg";